import CommentComposer from '@/components/Comment/CommentComposer';
import PostCommentFormHeader from '@/components/Comment/PostCommentFormHeader';
import { useCreateProjectGroupCommentMutation } from './comment.api.slice';

function ProjectGroupCommentForm({
  projectGroupId,
}: {
  projectGroupId: string;
}) {
  const [createComment] = useCreateProjectGroupCommentMutation();

  return (
    <div className="w-full h-fit gap-4 flex flex-col">
      <PostCommentFormHeader />
      <CommentComposer
        onSubmit={async (body) => {
          await createComment({ projectGroupId, comment: body }).unwrap();
        }}
      />
    </div>
  );
}

export default ProjectGroupCommentForm;
